import React from 'react';
import { ThemeProvider as ThemeProviderComponent } from 'styled-components';

import { Theme } from '../themeBase';

export type ThemeProviderProps = {
  /**
   * React children nodes
   */
  children: React.ReactNode;
  /**
   * Components theme
   */
  theme: Theme;
};

const ThemeProvider = ({ children, theme }: ThemeProviderProps) => (
  <ThemeProviderComponent theme={theme}>{children}</ThemeProviderComponent>
);

export default ThemeProvider;
